// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_1dWDa","listWrap":"index_listWrap_1QrxU"};